export const pushToGTM = (...tags) => {
	try {
		tags.forEach(tag => window.dataLayer.push(tag));
	} catch (e) {
		console.error('Error pushing tag:', e);
	}
};

export default pushToGTM;

// New GA4 tags ---------------------------------------------------------------------------------------

export const pageLoadGA4Tag = page => ({
	wdUpdateGA4: {
		action: 'select_step',
		label: page
	},
	event: 'wdUpdateGA4'
});

export const CLICK_ABOUT_GA4_TAG = {
	wdUpdateGA4: {
		action: 'select',
		label: 'About'
	},
	event: 'wdUpdateGA4'
};

export const CLICK_FEEDBACK_GA4_TAG = {
	wdUpdateGA4: {
		action: 'select',
		label: 'Feedback'
	},
	event: 'wdUpdateGA4'
};

export const clickSelectDesignGA4Tag = partNumber => ({
	wdUpdateGA4: {
		action: 'select_design',
		label: 'Based on IC: ' + partNumber
	},
	event: 'wdUpdateGA4'
});

export const clickCalculateDesignCalcTypeGA4Tag = vinNom => ({
	wdUpdateGA4: {
		action: 'calculate_design',
		label: vinNom === '' ? 'Basic calculation' : 'VinNom calculation'
	},

	event: 'wdUpdateGA4'
});

export const CLICK_LOGIN_GA4_TAG = {
	wdUpdateGA4: {
		action: 'login',
		label: 'Login'
	},

	event: 'wdUpdateGA4'
};

export const CLICK_LOGOUT_GA4_TAG = {
	wdUpdateGA4: {
		action: 'login',
		label: 'Logout'
	},

	event: 'wdUpdateGA4'
};

export const CLICK_OPEN_DESIGN_GA4_TAG = {
	wdUpdateGA4: {
		action: 'my_design',
		label: 'Open saved design'
	},
	event: 'wdUpdateGA4'
};

export const clickFavouriteDesignGA4Tag = favorite => ({
	wdUpdateGA4: {
		action: 'my_design',
		label: favorite === false ? 'Added design to favourite' : 'Removed design from favourite'
	},

	event: 'wdUpdateGA4'
});

export const RENAME_DESIGN_GA4_TAG = {
	wdUpdateGA4: {
		action: 'my_design',
		label: 'Rename Saved Design'
	},
	event: 'wdUpdateGA4'
};

export const CLICK_DATASHEET_GA4_TAG = {
	wdUpdateGA4: {
		action: 'redirect_to',
		label: 'Datasheet'
	},

	event: 'wdUpdateGA4'
};

export const CLICK_PRODUCT_PAGE_GA4_TAG = {
	wdUpdateGA4: {
		action: 'redirect_to',
		label: 'Product page'
	},
	event: 'wdUpdateGA4'
};

export const EXPORT_BOM_GA4_TAG = {
	wdUpdateGA4: {
		action: 'download',
		label: 'Bom'
	},
	event: 'wdUpdateGA4'
};

export const EXPORT_CHART_GA4_TAG = {
	wdUpdateGA4: {
		action: 'download',
		label: 'Chart'
	},
	event: 'wdUpdateGA4'
};

export const EXPORT_OPERATING_VALUES_GA4_TAG = {
	wdUpdateGA4: {
		action: 'download',
		label: 'OP values'
	},
	event: 'wdUpdateGA4'
};

export const EXPORT_PDF_REPORT_GA4_TAG = {
	wdUpdateGA4: {
		action: 'download',
		label: 'Summary report'
	},
	event: 'wdUpdateGA4'
};

export const EXPORT_SCHEMATIC_GA4_TAG = {
	wdUpdateGA4: {
		action: 'download',
		label: 'Schematic'
	},
	event: 'wdUpdateGA4'
};

export const OPEN_DESIGN_BY_GA4_TAG = {
	wdUpdateGA4: {
		action: 'opened_design_by',
		label: 'Design Link'
	},
	event: 'wdUpdateGA4'
};
